import type { IconProps } from '../types';

export const Check = ({ width = 24, height = 24, fill }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? 24}
    height={height ?? 24}
    viewBox="0 0 24 24"
    fill={'none'}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.74979 14.836L17.2928 7.29303C17.4803 7.10556 17.7346 7.00024 17.9998 7.00024C18.265 7.00024 18.5193 7.10556 18.7068 7.29303C18.8943 7.48056 18.9996 7.73487 18.9996 8.00003C18.9996 8.26519 18.8943 8.5195 18.7068 8.70703L10.4568 16.957C10.2693 17.1445 10.015 17.2498 9.74979 17.2498C9.48462 17.2498 9.23031 17.1445 9.04279 16.957L5.29279 13.207C5.10532 13.0195 5 12.7652 5 12.5C5 12.2349 5.10532 11.9806 5.29279 11.793C5.48031 11.6056 5.73462 11.5002 5.99979 11.5002C6.26495 11.5002 6.51926 11.6056 6.70679 11.793L9.74979 14.836Z"
      fill={fill ?? '2C2E31'}
    />
  </svg>
);
